<template>
  <div class="dash-section">
    <div class="header">
      <div>
        <h2 class="title">Filter By User Tag</h2>
      </div>
    </div>
    <div class="custom-tags">
      <custom-tags-input :value="value" @input="setCustomTags" />
    </div>
  </div>
</template>

<script>
import CustomTagsInput from '../../CustomTagsInput.vue';

export default {
  name: 'CustomUserTagsSection',
  components: {
    CustomTagsInput
  },
  props: {
    value: {
      type: Array,
        required: true
      },
  },
  methods: {
    setCustomTags(tagsList) {
      this.$emit('input', tagsList);
    }
  }
}
</script>

<style lang="scss">

.custom-tags {
  padding-left: 2.45rem;
  padding-bottom: 1.5rem;
}
</style>
